import React from 'react';

const Help = () => {
    return (
        <div className="space-y-6">
            <div className="border-b pb-4">
                <h3 className="text-lg font-semibold text-gray-800 mb-2">Manage Fuel History</h3>
                <p className="text-sm text-gray-600">
                    Track fuel logs and expenses for your fleet.
                </p>
            </div>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Logging Fuel Entries</h4>
                <ul className="list-disc pl-5 space-y-2 text-sm text-gray-600">
                    <li>Click <strong>Add Fuel</strong> to record a new transaction.</li>
                    <li>Enter details like <strong>Vehicle</strong>, <strong>Vendor</strong>, <strong>Quantity</strong>, <strong>Cost</strong>, and current <strong>Odometer</strong> reading.</li>
                </ul>
            </section>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Analyzing Data</h4>
                <ul className="list-disc pl-5 space-y-2 text-sm text-gray-600">
                    <li>Use the <strong>Date Range Picker</strong> to view logs for a specific period.</li>
                    <li>Use the <strong>Search Bar</strong> to find logs by vehicle or vendor name.</li>
                    <li>The table displays the Calculate <strong>MPG</strong> (implied by data) or cost efficiency.</li>
                </ul>
            </section>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Export Data</h4>
                <ul className="list-disc pl-5 space-y-2 text-sm text-gray-600">
                    <li>Select specific rows to include in the report.</li>
                    <li>Export the list to <strong>PDF</strong> or <strong>CSV</strong> for expense reporting.</li>
                </ul>
            </section>
        </div>
    );
};

export default Help;
